import { WithTranslation, withTranslation } from 'react-i18next';
import { Alert } from '@vivaahealth/design-system';

import { RteState } from '../../types';

import * as api from '../../../../../../api';

interface RteErrorAlertProps extends WithTranslation {
  rteError: RteState['error'];
}

const RteErrorAlert = ({ rteError, t }: RteErrorAlertProps) => {
  switch (rteError) {
    case api.PatientRealTimeEligibility.EligibilityResponse.Inactive:
      return (
        <Alert variant="danger" title={t('rteInactiveErrorTitle')}>
          {t('rteInactiveErrorDescription')}
        </Alert>
      );
    default:
      return null;
  }
};

export default withTranslation('rteErrorReviewPage')(RteErrorAlert);
